import Api from './baseApi';
export default {
    searchDiscount: (discount) => {
        let url = "/api/discounts?v=1";
        if (discount.search)
            url += `&q=${discount.search}`;
        if (discount.state > -1)
            url += `&state=${discount.state}`;
        return Api.get(url)
    },
    getDiscounts: () => Api.get("/api/discounts/"),
    getDiscount: (id) => Api.get(`/api/discounts/${id}`),
    putDiscount: (discount) => Api.put(`/api/discounts/${discount.id}`, discount),
    deleteDiscount: (discount) => Api.delete(`/api/discounts/${discount.id}`, discount),
    postDiscount: (discount) => Api.post("/api/discounts/", discount)

}